<template>
  <v-content>
    <v-container fluid style="position: relative">
      <v-row no-gutters>
        <v-col cols="12">
          <v-card>
            <v-container fluid>
              <v-card-title>      
                <v-btn icon @click="gotoUsers">
                  <v-icon>mdi-arrow-left</v-icon>
                </v-btn>
                {{ 'External Users' | translate }}
              </v-card-title>
              <v-divider></v-divider>
              <v-card-text>
                <v-row v-if="errors != 'Seats are full'">
                  <v-col cols="12" sm="8" md="8">
                    <v-alert
                      dense
                      v-for="(v, k) in errors"
                      :key="k"
                      outlined
                      type="error"
                    >{{ k }} {{ v }}</v-alert>
                  </v-col>
                </v-row>
                <v-row v-else>
                  <v-col cols="12" sm="8" md="8">
                    <v-alert dense outlined type="error">{{ errors }}</v-alert>
                  </v-col>
                </v-row>
                <v-form id="form" ref="form">
                  <v-row>
                    <v-col cols="12" sm="8" md="8">
                      <v-row>
                        <v-col cols="12" sm="3">
                          <v-text-field
                            v-model="salutation"
                            :label="'Title' | translate"
                            name="title"
                            :rules="salutationRules"
                            :disabled="(Object.keys(currentUser).length !=0 && currentUser.roles.includes(1)? false :true )"
                            outlined
                            required
                          >
                          <template #message="{ message }">
                            {{ (curLanguage.lang_code == 'en' ? message : $t(message))}}
                          </template>               
                          </v-text-field>
                        </v-col>
                        <v-col cols="9" sm="9">
                          <v-text-field
                            outlined
                            :label="'Name' | translate"
                            v-model="name"
                            name="name"
                            :rules="nameRules"
                            autocomplete="off"
                            :disabled="(Object.keys(currentUser).length !=0 && currentUser.roles.includes(1)? false :true )"
                            required
                          >      
                          <template #message="{ message }">
                            {{ (curLanguage.lang_code == 'en' ? message : $t(message))}}
                          </template>               
                          </v-text-field>
                        </v-col>
                      </v-row>

                      <v-row>
                        <v-col cols="12" sm="12">
                          <v-text-field
                            outlined
                            :label="'Email' | translate"
                            v-model="email"
                            name="email"
                            autocomplete="off"
                            :rules="emailRules"
                            type="email"
                            :disabled="(Object.keys(currentUser).length !=0 && currentUser.roles.includes(1)? false :true )"
                            required
                          >
                          <template #message="{ message }">
                            {{ (curLanguage.lang_code == 'en' ? message : $t(message))}}
                          </template>                                         
                          </v-text-field>
                        </v-col>
                      </v-row>

                      <v-row>
                        <v-col cols="12" sm="12">
                          <v-text-field
                            outlined
                            :label="'Phone Number' | translate"
                            v-model="phone_no"
                            name="phone_no"
                            autocomplete="off"
                            :rules="numberRules"
                            type="text"
                            :disabled="(Object.keys(currentUser).length !=0 && currentUser.roles.includes(1)? false :true )"
                            required
                          >
                          <template #message="{ message }">
                            {{ (curLanguage.lang_code == 'en' ? message : $t(message))}}
                          </template>                                         
                          </v-text-field>
                        </v-col>
                      </v-row>

                      <v-row>
                        <v-col cols="12" sm="12">
                          <v-textarea
                            outlined
                            name="address"
                            v-model="address"
                            :rules="addressRules"
                            autocomplete="off"
                            :disabled="(Object.keys(currentUser).length !=0 && currentUser.roles.includes(1)? false :true )"
                            :label="'Address' | translate"
                          >
                          <template #message="{ message }">
                            {{ (curLanguage.lang_code == 'en' ? message : $t(message))}}
                          </template>               
                          </v-textarea>
                        </v-col>
                      </v-row>

                      <v-row v-if="user_id !== null ">
                        <v-col cols="12">
                          <v-tabs
                            v-model="tabs"
                            fixed-tabs
                          >
                            <v-tabs-slider></v-tabs-slider>
                            <v-tab
                              href="#userdocuments"
                              class="primary--text"
                            >
                              {{ 'User documents' | translate}}
                            </v-tab>

                            <v-tab
                              href="#certifications"
                              class="primary--text"
                            >
                              {{ 'Certifications' | translate }}
                            </v-tab>

                          </v-tabs>

                        <v-tabs-items v-model="tabs">
                          <v-tab-item value="userdocuments">
                            <v-card flat> 
                              <v-data-table
                                :headers="personaldocumentheaders"
                                :items="personaldocuments"
                                :single-expand="singleExpand"
                                :expanded.sync="expanded"
                                item-key="perdoc_name"
                                show-expand
                                class="elevation-1"
                                :footer-props="{ 'items-per-page-text': footertext, 'itemsPerPageOptions':[5,10,20,{ text: $t('All'), value: -1 }]   }"
                              >
                                <template slot="no-data">
                                    {{ 'No data available' | translate }}
                                </template>
                                  <template v-slot:footer.page-text="items"> 
                                    {{ items.pageStart }} - {{ items.pageStop }} {{ 'of' | translate}} {{ items.itemsLength }} 
                                  </template>                          
                                <template v-slot:item.template ="{ item }" >
                                    <v-btn class="white--text" small :color="primary_color"  v-on:click="downloadPersonal(item.temp_files[0])">{{ 'View'| translate }}</v-btn>
                                </template>   
                                <template v-slot:item.update ="{ item }" >
                                    <v-btn class="white--text" small :color="primary_color"  v-on:click="openDialog(item.temp_files[0].temp_id, item.temp_validity, item.temp_type)" >{{ 'Update user documents'| translate }}</v-btn>
                                </template>  
                                  <template v-slot:item.data-table-expand="{ item ,expand, isExpanded }">
                                    <v-icon v-if="!isExpanded" @click="expand(!isExpanded); showUserDocuments(item.temp_files[0].temp_id)">mdi-chevron-down</v-icon>
                                    <v-icon v-if="isExpanded" @click="expand(!isExpanded)">mdi-chevron-up</v-icon>
                                  </template>
                                <template v-slot:top>
                                  <v-card-title>
                                  </v-card-title>
                                   <v-toolbar  flat color="white">
                                    <v-spacer></v-spacer>
                                    <v-text-field v-model="searchuserdocuments" append-icon="search" :label="'Search' | translate" single-line hide-details></v-text-field>
                                   </v-toolbar>
                                </template>
                                <template v-slot:expanded-item="{ headers }">
                                  <td :colspan="headers.length" style='padding: 0px !important;'>
                                  <v-data-table
                                    :headers="subdocumentheaders"
                                    :items="userdocuments"
                                    item-key="created_at"
                                    class="elevation-1"
                                    hide-default-footer
                                  >
                                  <template slot="no-data">
                                      {{ 'No data available' | translate }}
                                  </template>
                                  <template v-slot:footer.page-text="items"> 
                                    {{ items.pageStart }} - {{ items.pageStop }} {{ 'of' | translate}} {{ items.itemsLength }} 
                                  </template>
                                  <template v-slot:item.view ="{ item }">
                                      <v-btn class="white--text" small :color="primary_color"  v-on:click="downloadUser(item.ud_id, item.updated_at, item.extension)">{{ 'View'| translate }}</v-btn>
                                  </template>  
                                  <template v-slot:item.edit ="{ item }">
                                      <v-btn class="white--text" small :color="primary_color" v-on:click="openeditDialog(item.ud_id,item.temp_id,item.due_date)">{{ 'Edit'| translate }}</v-btn>
                                  </template> 
                                  </v-data-table> 
                                  </td>                           
                                </template>
                              </v-data-table>
                            </v-card>
                          </v-tab-item>  
                          <v-tab-item value="certifications">
                            <DataTable
                              title=""
                              :headers="certificateheaders"
                              :items="usercertificates"
                              :search="searchcertificate"
                            /> 
                          </v-tab-item>    
                        </v-tabs-items>                
                        </v-col>
                      </v-row>
                    </v-col>

                    <v-col cols="12" sm="4" md="4">
                       <v-row v-if='Object.keys(currentUser).length !=0 && currentUser.roles.includes(1)'>
                         <v-col cols="12" sm="12" md="12">
                           <v-autocomplete
                             v-model="roles_id"
                              :items="userRoles"
                              item-value="role_id"
                              item-text="role_name"
                              :label="'Roles' | translate"
                              :rules="rolesRules"
                              outlined
                              chips
                              :disabled="(currentUser.roles.includes(1)? false :true )"
                              small-chips
                              multiple
                              required
                              :no-data-text="$t('No data available')"
                            >
                          <template #message="{ message }">
                            {{ (curLanguage.lang_code == 'en' ? message : $t(message))}}
                          </template>                                           
                            </v-autocomplete>
                        </v-col>
                      </v-row>
                   </v-col>



                  </v-row>
                </v-form>
                <v-dialog v-model="dialog" persistent max-width="500">
                  <v-card>
                    <v-card-title class="headline" v-if='editDocument'>{{ 'Edit user documents' | translate }}</v-card-title>
                    <v-card-title class="headline" v-else>{{ 'Update user documents' | translate }}</v-card-title>
                    <v-card-text>
                        <v-card-text>
                          <v-container>
                            <v-form id="modelform" ref="modelform">
                              <v-row>

                                <v-col v-if="documenterrors" cols="12" sm="12" md="12">
                                  <v-alert
                                    dense
                                    v-for="(v, k) in documenterrors"
                                    :key="k"
                                    outlined
                                    type="error"
                                  >{{ k }} {{ v }}</v-alert>
                                </v-col>
                              </v-row>
                              <v-row>
                                <v-col cols="12" sm="12" v-if='editDocument ==false'>
                                    <v-file-input
                                        id="document_file"
                                        name="file"
                                        outlined
                                        chips
                                        required
                                        :label="'Select file' | translate"
                                        @change="onFileSelected"
                                    ></v-file-input>
                                </v-col>

                                <v-col cols="12" sm="12">
                                  <v-autocomplete
                                      v-model="status"
                                      :items="statusvalues"
                                      item-value="value"
                                      item-text="text"
                                      :label="'Status' | translate"
                                      :rules="statusRules"
                                      outlined
                                      chips
                                      small-chips
                                      required
                                      :no-data-text="$t('No data available')"
                                    >
                                    <template #message="{ message }">
                                      {{ (curLanguage.lang_code == 'en' ? message : $t(message))}}
                                    </template>                                                   
                                    </v-autocomplete>
                                </v-col>

                                <v-col cols="12" sm="12">
                                  <v-menu
                                    ref="menu"
                                    v-model="menu"
                                    :close-on-content-click="true"
                                    
                                    transition="scale-transition"
                                    offset-y
                                    min-width="290px"
                                  >
                                    <template v-slot:activator="{ on, attrs }">
                                      <v-text-field
                                        outlined
                                        :label="'Due date' | translate"
                                        v-model="due_date"
                                        name="due_date"
                                        :rules="dateRules"
                                        autocomplete="off"
                                        required
                                        prepend-icon="mdi-calendar"
                                        v-bind="attrs"
                                        v-on="on"

                                      >
                                      <template #message="{ message }">
                                        {{ (curLanguage.lang_code == 'en' ? message : $t(message))}}
                                      </template>                                
                                      </v-text-field>


                                    </template>
                                    <v-date-picker
                                      v-model="due_date"
                                      no-title
                                      scrollable
                                      :locale="curLanguage.lang_code"
                                      @input="menu=false"
                                    >
                                    </v-date-picker>
                                  </v-menu>
                                </v-col>

                                <v-col cols="12" sm="12">
                                  <v-textarea
                                    outlined
                                    name="comment"
                                    v-model="comment"
                                    autocomplete="off"
                                    :label="'Comment (optional)' | translate"
                                  >
                                  <template #message="{ message }">
                                    {{ (curLanguage.lang_code == 'en' ? message : $t(message))}}
                                  </template>                                                 
                                  </v-textarea>
                                </v-col> 

                              </v-row>

                            </v-form>
                          </v-container>
                        </v-card-text>                      
                    </v-card-text>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="green darken-1" text @click="closeBox">{{ 'Close' | translate }}</v-btn>
                      <v-btn color="green darken-1" v-if="editDocument" text @click='editPersonalDocument()'>{{ 'Update' | translate }}</v-btn>
                      <v-btn color="green darken-1" v-else text @click='uploadDocument'>{{ 'Upload' | translate }}</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>


                <v-btn
                  dark
                  fab
                  fixed
                  bottom
                  right
                  large
                  color="pink"
                  class="mx-2"
                  v-if="user_id != '' && Object.keys(currentUser).length !=0 && currentUser.roles.includes(1)"
                  @click="submit"
                >
                  <v-icon>mdi-content-save</v-icon>
                </v-btn>
                <v-btn
                  dark
                  fab
                  fixed
                  bottom
                  right
                  large
                  color="pink"
                  class="mx-2"
                  v-if="user_id && Object.keys(currentUser).length !=0 && currentUser.roles.includes(1)"
                  @click="update"
                >
                  <v-icon>mdi-content-save</v-icon>
                </v-btn>
              </v-card-text>
            </v-container>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </v-content>
</template>
<style lang="scss">
.v-data-footer {
  -webkit-box-pack: start !important;
  -ms-flex-pack: start !important;
  justify-content: flex-start !important;
  -webkit-box-align: center !important;
  -ms-flex-align: center !important;
  align-items: center !important;
}

.v-application--is-ltr .v-data-footer__select {
  margin-left: 16px !important;
}
</style>

<script>
import {
  ADD_USER,
  FETCH_USERS,
  FETCH_GROUPS,
  FETCH_ROLES,
  RESET_STATE,
  FETCH_INDIVIDUAL_USER,
  FETCH_USER_DOCUMENTS,
  DOWNLOAD_PERSONAL_DOCUMENT,
  DOWNLOAD_USER_DOCUMENT,
  UPDATE_USER_DOCUMENT,
  FETCH_PERSONAL_DOCUMENTS,
  FETCH_USER_CERTIFICATES,
  UPDATE_USER
} from "@/store/actions.type";
import {  SET_SNACKBAR, SET_LOADING, SET_ROUTER_ENTER } from "@/store/mutations.type";
import store from "@/store";
import { mapState } from "vuex";
import { mapGetters } from "vuex";
export default {
  name: "AddEditUser",
  async beforeRouteEnter(to, from, next) {
    if(to.params.id){
    await store.dispatch(FETCH_INDIVIDUAL_USER, to.params.id)
      if((!store.getters.individualuser.roles.includes(6)) && (to.name=='editextusers') ){ //user editing not possible in ext users, redirect to correct route
        next({ path: '/users/edit/'+to.params.id });
      }
    }
    Promise.all([
      store.dispatch(RESET_STATE),
       store.dispatch(FETCH_USERS, ''),
      (store.getters.currentUser.roles.includes(1)?store.dispatch(FETCH_GROUPS, ''): ''),
      (store.getters.currentUser.roles.includes(1)?store.dispatch(FETCH_ROLES, ''):''),      
      (to.params.id ? store.dispatch(FETCH_INDIVIDUAL_USER, to.params.id) : ''),
      (to.params.id ? store.dispatch(FETCH_PERSONAL_DOCUMENTS, '?user_id='+to.params.id) : ''),
      (to.params.id ? store.dispatch(FETCH_USER_CERTIFICATES, 'course-certificates?user_id='+to.params.id) : ''),
    ]).finally(() => {
      store.commit(SET_LOADING, false)
      store.commit(SET_ROUTER_ENTER, false)
    });

    return next();
  },
  components: {
    DataTable: () => import("@/components/datatable/datatable")
  },  
  data: function() {
    return {
      tabs: null,
      name: "",
      email: "",
      address: "",
      phone_no: "",
      salutation: "",
      searchuserdocuments:'',
      searchcertificate: '',
      user_id: null,
      roles_id:[],
      doc_id: null,
      due_date: null,
      status: null,
      comment: null,
      personaldocumentid: null,
      file: null,
      group_admins: [],
      editDocument: false,
      expanded: [],
      dialog: false,
      singleExpand: true,
      groups_id:[],
      menu:false,
      temp_type: null,
      primary_color: null,
    };
  },
  computed: {
    ...mapGetters(['individualuser', 'roles', 'groups', 'personaldocuments', 'userdocuments','currentUser','curLanguage', 'usercertificates']),
    statusvalues(){ 
      return [
        { value: "active", text: this.$t("Active") },
        { value: "inactive", text: this.$t("Inactive") },
      ]
    },  
    emailRules(){ 
      return [v => /.+@.+/.test(v) || "Invalid Email address"]
    },
    numberRules(){ 
      return [
      v => !!v || "Phone Number is required",
      v => Number.isInteger(Number(v)) || "The value must be an integer number"
      ]
    },
    salutationRules(){ 
      return [v => !!v || "Title is required",
      (v) =>  (v && v.length <= 20) || "Title must be less than 20 characters"
      ] 
    },
    addressRules(){
      return [v => !!v || "Address is required"]
    },
    rolesRules(){ 
      return [v => !!(v && v.length) || "Role is required"]
    },
    groupsRules(){ 
      return [v => !!v || "Groups are required"]
    },
    statusRules(){ 
      return [v => !!v || "Status is required"]
    },
    dateRules(){ 
      return [v => !!v || "Date is required"]
    },
    salutationvalues(){
      let salutationData = [
        { value: "Mr", name: this.$t("Mr") },
        { value: "Mrs", name: this.$t("Mrs") }
      ]
      return salutationData
    },  
    nameRules(){
      let namerule = [(v) => !!v || "Name is required"]
      return namerule
    },  
    footertext(){
      return this.$t('Rows per page')
    },    
    ...mapState({
      errors: state => state.users.usererrors,
      documenterrors: state => state.documents.documenterrors
    }),
    userRoles(){
      return this.roles.filter(data=>data.role == 'external-user')
    },
    personaldocumentheaders(){
      return  [
        { text: this.$t('User document name'), value: "temp_name" },
        {text: this.$t('Days until'), value: "temp_validity"},
        {text: this.$t('Template'), value:'template'},
        {text: this.$t('Update'), value:'update'},
        { text: '', value: 'data-table-expand' },
      ]
    },
    certificateheaders(){
      return  [
        { text: this.$t('Course name'), value: "course_name" },
        {text: this.$t('Completed on'), value: "passed_on"},
        { text: this.$t('View'), value: 'view_certificate' },
      ]
    },
    subdocumentheaders(){
      return [
            { text: this.$t("Status"), value: "status" },       
            { text: this.$t("Due date"), value: "due_date" },  
            { text: this.$t("Uploaded by"), value: "uploaded_user" },  
            { text: this.$t("Uploaded on"), value: "created_at" },
            { text: this.$t('Edit'), value: 'edit' },
            { text: this.$t('View'), value: 'view' },
          ]
    }
  },
  watch: {
    individualuser(value) {
      if(Object.keys(value).length>0){
        this.renderData()
      }
    }
  },
  created () {
    if(this.currentUser.roles.includes(1) ==false && this.currentUser.roles.includes(3)== false){
      this.$router.push('/dashboard');
    }
    let company_meta  = JSON.parse(this.currentUser.company.company_meta)
    this.primary_color  = company_meta.primary_color
  },
  mounted(){
    let company_meta  = JSON.parse(this.currentUser.company.company_meta)

    if(this.currentUser.roles.includes(1) && (company_meta.has_external_users == 'false' || company_meta.has_external_users == null) ){
      this.$router.push('/dashboard')
    }
  }, 
  methods: {
    gotoUsers() {
      this.$router.push({ name: "extusers" });
    },  
    onFileSelected() {
      this.file = document.getElementById("document_file").files[0];
    },      
    renderData() {
      this.name = this.individualuser.name;
      this.email = this.individualuser.email;
      this.phone_no = this.individualuser.phone_no;
      this.address = this.individualuser.address;
      this.salutation = this.individualuser.salutation;
      this.user_id = this.individualuser.user_id
      this.roles_id =  this.individualuser.roles
    }, 
    async downloadPersonal(documentdata){
      await this.$store
        .dispatch(DOWNLOAD_PERSONAL_DOCUMENT, 'view-file/'+documentdata.temp_file_id)
        .then(resp => {
          var fileURL = window.URL.createObjectURL(new Blob([resp]));
          var fileLink = document.createElement('a');
          fileLink.href = fileURL;
          fileLink.setAttribute('download', documentdata.updated_at+'.'+documentdata.extension);
          document.body.appendChild(fileLink);
          fileLink.click(); 
          store.commit(SET_LOADING, false);

        });
    },
    async downloadUser(id, name , extension){
      await this.$store
        .dispatch(DOWNLOAD_USER_DOCUMENT, 'view-file/'+id)
        .then(resp => {
          var fileURL = window.URL.createObjectURL(new Blob([resp]));
          var fileLink = document.createElement('a');
          fileLink.href = fileURL;
          fileLink.setAttribute('download', name+'.'+extension);
          document.body.appendChild(fileLink);
          fileLink.click(); 
          store.commit(SET_LOADING, false);

        });
    },
    openDialog(id, days, type){
      var currentDate = new Date()
      var validdate = new Date()
      validdate.setDate(currentDate.getDate()+days)
      this.dialog= true
      this.doc_id = id
      this.file=  null
      this.comment  = null
      this.due_date = validdate.toISOString().slice(0,10)
      this.status = null
      this.temp_type = type
      document.getElementById('document_file').value=''
    },
    openeditDialog(udid, idpersonaldocument,  duedate){
      this.dialog= true
      this.doc_id = udid
      this.file=  null
      this.personaldocumentid = idpersonaldocument
      this.comment  = null
      this.due_date = duedate
      this.status = null
      this.editDocument = true
    },    
    closeBox(){
      document.getElementById("modelform").reset();
      this.dialog = false
      this.editDocument = false
    },
    async showUserDocuments(tempid){
      await this.$store.dispatch(FETCH_USER_DOCUMENTS,'?item_id='+this.individualuser.user_id+'&temp_id='+tempid+'&inbox_filter=false').then(resp=>{
        if (resp != undefined && resp.hasOwnProperty('success') && resp.success) {
          this.$store.commit(SET_LOADING, false)
        }
        else{
          this.$store.commit(SET_LOADING, false)
        }
      })
    },
    async editPersonalDocument(){
      if (this.$refs.modelform.validate()) {
          var formData = new FormData(document.getElementById("modelform"));
          formData.set("item_id", this.individualuser.user_id)
          formData.set("temp_id", this.personaldocumentid)
          formData.set('status', this.status)
          formData.set('due_date', this.due_date)
          formData.set('comment', this.comment)
          formData.set('ud_id', this.doc_id)
          formData.set('_method', 'put')
          this.$store.dispatch(UPDATE_USER_DOCUMENT, formData).then(async resp => {
            if (resp !==undefined && resp.success) {
                  await this.showUserDocuments(this.personaldocumentid)
                  store.commit(SET_SNACKBAR, {status: true, message: 'User document updated successfully'})
                  this.dialog =false
                  this.doc_id = null
                  this.file=  ''
                  this.comment  = ''
                  this.due_date = ''
                  this.status = ''
                  this.editDocument = false
                  this.personaldocumentid = null 
                  this.$refs.modelform.reset()              
                  store.commit(SET_LOADING, false)

            }
            else if(resp !==undefined && !resp.success){
              store.commit(SET_LOADING, false)
            }
          });

    
      }
    },    
    async uploadDocument(){
      if (this.$refs.modelform.validate()) {
        if (this.file != null) {
          var formData = new FormData(document.getElementById("modelform"));
          formData.set("file", this.file)
          formData.set("item_id", this.user_id)
          formData.set("temp_id", this.doc_id)
          formData.set('status', this.status)
          formData.set('due_date', this.due_date)
          formData.set('comment', this.comment)
          this.$store.dispatch(UPDATE_USER_DOCUMENT, formData).then(async resp => {
            if (resp !==undefined && resp.success) {
                  await this.showUserDocuments(this.doc_id)
                  store.commit(SET_SNACKBAR, {status: true, message: 'User document updated successfully'})
                  this.$refs.modelform.reset()
                  this.dialog =false
                  this.doc_id = null
                  this.file=  null
                  this.comment  = null
                  this.due_date = null
                  this.status = null
                  this.editDocument = false
                  this.personaldocumentid = null                
                  store.commit(SET_LOADING, false)

            }
            else if(resp !==undefined && !resp.success){
              store.commit(SET_LOADING, false)
            }
          });

        }
      }
    },
    submit: function() {
      if (this.$refs.form.validate()) {
        this.$store
          .dispatch(ADD_USER, {
            email: this.email,
            name: this.name,
            address: this.address,
            phone_no: this.phone_no,
            salutation: this.salutation,
            roles: this.roles_id,
          })
          .then(resp => {
            if (resp != undefined && resp.hasOwnProperty('success') && resp.success) {
              store.commit(SET_SNACKBAR, {status: true, message: 'User created successfully'})
              store.commit(SET_LOADING, false)
              this.$router.push({ name: "extusers" });
            }
            else{
              store.commit(SET_LOADING, false)
            }
          });
      }
    },
    update: function() {
      if (this.$refs.form.validate()) {
        this.$store
          .dispatch(UPDATE_USER, {
            email: this.email,
            name: this.name,
            address: this.address,
            phone_no: this.phone_no,
            salutation: this.salutation,
            user_id: this.user_id,
            roles: this.roles_id, 
            status: this.individualuser.status,        
            _method: "put"
          })
          .then(resp => {
            if (resp != undefined && resp.hasOwnProperty('success') && resp.success) {
              store.commit(SET_SNACKBAR, {status: true, message: 'User updated successfully'})
              store.commit(SET_LOADING, false)
              this.$router.push({ name: "extusers" });
            }
            else{
              store.commit(SET_LOADING, false)
            }

          });
      }
    }
  }
};
</script>